/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DataPointStats } from './DataPointStats';
import {
    DataPointStatsFromJSON,
    DataPointStatsFromJSONTyped,
    DataPointStatsToJSON,
    DataPointStatsToJSONTyped,
} from './DataPointStats';

/**
 * 
 * @export
 * @interface PaginatedDataPointStatsList
 */
export interface PaginatedDataPointStatsList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedDataPointStatsList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedDataPointStatsList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedDataPointStatsList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<DataPointStats>}
     * @memberof PaginatedDataPointStatsList
     */
    results: Array<DataPointStats>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedDataPointStatsList
     */
    numPages?: number;
}

/**
 * Check if a given object implements the PaginatedDataPointStatsList interface.
 */
export function instanceOfPaginatedDataPointStatsList(value: object): value is PaginatedDataPointStatsList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedDataPointStatsListFromJSON(json: any): PaginatedDataPointStatsList {
    return PaginatedDataPointStatsListFromJSONTyped(json, false);
}

export function PaginatedDataPointStatsListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedDataPointStatsList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] === undefined ? undefined : json['next'] === null ? null : json['next'],
        'previous': json['previous'] === undefined ? undefined : json['previous'] === null ? null : json['previous'],
        'results': ((json['results'] as Array<any>).map(DataPointStatsFromJSON)),
        'numPages': json['num_pages'] == null ? undefined : json['num_pages'],
    };
}

export function PaginatedDataPointStatsListToJSON(json: any): PaginatedDataPointStatsList {
    return PaginatedDataPointStatsListToJSONTyped(json, false);
}

export function PaginatedDataPointStatsListToJSONTyped(value?: PaginatedDataPointStatsList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(DataPointStatsToJSON)),
        'num_pages': value['numPages'],
    };
}

